import envVar from '../config/envVars';
import httpGet from './httpClient/httpGet';
import { SchoolConfig } from '../types/schoolConfigType';
import httpPost from './httpClient/httpPost';
import authenticationUtils from '../utils/authenticationUtils';

const getPaymentConfigBySchool = async (school: string) =>
  httpGet(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/payments-configs/${school}`,
    {
      headers: {
        Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
      }
    }
  );

const upsertPaymentConfig = async (config: Partial<SchoolConfig>) =>
  httpPost(
    `${envVar.REACT_APP_PAYMENTS_API_BASE_URL}/payments-configs`,
    config,
    {
      headers: {
        Authorization: `Bearer ${authenticationUtils.getEasypayToken()}`
      }
    }
  );

export { getPaymentConfigBySchool, upsertPaymentConfig };
